import type { FC } from 'react';
import { Toaster as SonnerToaster } from 'sonner';
import styles from './Toaster.module.css';

export const Toaster: FC = () => (
    <SonnerToaster
        gap={8}
        position="top-center"
        className={styles.toaster}
        toastOptions={{
            unstyled: true,
            classNames: {
                toast: styles.toast,
                content: styles.content,
                icon: styles.icon,
                success: styles.success,
                error: styles.error,
                loading: styles.loading,
                warning: styles.warning
            }
        }}
    />
);
